import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { refUrl } from "@/lib/api";

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav aria-label="Breadcrumb" className="text-sm" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1 text-[var(--muted)]">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1">
              {i > 0 && <ChevronRight size={13} className="text-[var(--line)]" />}
              {last ? (
                <span className="text-[var(--ink-soft)] font-semibold" aria-current="page">
                  {it.name}
                </span>
              ) : (
                <Link
                  to={refUrl(it)}
                  className="wikilink"
                  data-testid={`breadcrumb-${it.type || "link"}`}
                >
                  {it.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
